const { mergeMap } = require("rxjs/operators");
const { ofType } = require("redux-observable");

const { marketplace: marketplaceApi } = require("@doctoroncallcom/api");
const {
  GET_COUPON,
  GET_COUPON_LIST,
  GET_COUPON_SUGGESTION,
  APPLY_COUPON,
} = require("./constants");

const {
  couponSuccess,
  couponError,
  couponListSuccess,
  couponListError,
  couponSuggestionSuccess,
  couponSuggestionError,
  applyForCouponSuccess,
  applyForCouponError,
} = require("./actions");

const coupon = (action$, state$, { marketplace }) =>
  action$.pipe(
    ofType(GET_COUPON),
    mergeMap((action) =>
      marketplaceApi.marketCoupon
        .coupon(marketplace, action.payload.id)
        .then((response) => couponSuccess(response.data))
        .catch((error) => couponError(error))
    )
  );

const couponList = (action$, state$, { marketplace }) =>
  action$.pipe(
    ofType(GET_COUPON_LIST),
    mergeMap((action) =>
      marketplaceApi.marketCoupon
        .couponByName(marketplace, action.payload.name)
        .then((response) => couponListSuccess(response.data))
        .catch((error) => couponListError(error))
    )
  );

const couponSuggestion = (action$, state$, { marketplace }) =>
  action$.pipe(
    ofType(GET_COUPON_SUGGESTION),
    mergeMap((action) =>
      marketplaceApi.marketCoupon
        .couponSuggestion(marketplace, { carts: action.payload.carts })
        .then((response) => couponSuggestionSuccess(response.data))
        .catch((error) => couponSuggestionError(error))
    )
  );

const applyForCoupon = (action$, state$, { marketplace }) =>
  action$.pipe(
    ofType(APPLY_COUPON),
    mergeMap((action) =>
      marketplaceApi.marketCoupon
        .applyForCoupon(marketplace, {
          cartArray: action.payload.cartArray,
          coupon_code: action.payload.couponCode,
          coupon_type: action.payload.couponType,
        })
        .then((response) => applyForCouponSuccess(response.data))
        .catch((error) => applyForCouponError(error))
    )
  );
module.exports = {
  coupon,
  couponList,
  couponSuggestion,
  applyForCoupon,
};
